export default __webpack_public_path__ + "static/media/angle-right-solid.cd2a56f4.svg";